import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
    getTodosAPI,
    addTodoAPI,
    updateTodoAPI,
    deleteTodoAPI,
    toggleTodoStatusAPI,
} from "../lib/api/todoApi";

export const useTodos = () => {
    return useQuery({
        queryKey: ["todos"],
        queryFn: getTodosAPI,
    });
};

export const useAddTodo = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: addTodoAPI,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["todos"] });
        },
    });
};

export const useUpdateTodo = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: updateTodoAPI,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["todos"] });
        },
    });
};

export const useDeleteTodo = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: deleteTodoAPI,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["todos"] });
        },
    });
};

export const useToggleTodoStatus = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: toggleTodoStatusAPI,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["todos"] });
        },
    });
};
